function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.375,
  cy: 20.625,
  rx: 20,
  ry: 19.375,
  fill: "#0E72ED"
});
var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.375,
  cy: 19.375,
  rx: 20,
  ry: 19.375,
  fill: "#0E72ED"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.472 23.313l15.032 14.562c6.129-1.875 10.968-6.563 12.903-12.5L29.214 15.5l-17.742 7.813z",
  fill: "#000"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.375 11.25c-6.387 0-11.613 6.875-11.613 8.125S13.988 27.5 20.375 27.5s11.613-6.875 11.613-8.125-5.226-8.125-11.613-8.125z",
  fill: "#FFFCF2"
});
var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.375,
  cy: 19.375,
  rx: 5.161,
  ry: 5,
  fill: "#0E72ED"
});
var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 19.085,
  cy: 18.125,
  rx: 1.29,
  ry: 1.25,
  fill: "#FFFCF2"
});
function SvgCourseAdminTabLastVisited(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 41 40",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}
export default __webpack_public_path__ + "fonts/course-admin-tab-last-visited-11c6209bac99285bcd530fddbafdbef0.svg";
export { SvgCourseAdminTabLastVisited as ReactComponent };